import { Injector } from '@angular/core';
import {
  FieldBuilder,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
} from '@zendra/shared';
import { ConservationTypeService, PropertyTypeService } from 'cbd-proxies';
import { EMPTY, defer, expand, map, reduce } from 'rxjs';

FieldBuilder.setNamespace('Geographic');

export const GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_FIELDS = [
  FieldBuilder.text('propertyName', 'Entity.GisProtectedAreaInconsistency.PropertyName').readOnly().build(),
  FieldBuilder.text('otherUseNames', 'Entity.GisProtectedAreaInconsistency.OtherUseNames').readOnly().build(),
  FieldBuilder.number('area', 'Entity.GisProtectedAreaInconsistency.ZendraArea').decimal().readOnly().build(),
  FieldBuilder.text('conservationType', 'Entity.GisProtectedAreaInconsistency.ConservationType').readOnly().build(),
  FieldBuilder.text('propertyTypeNames', 'Entity.GisProtectedAreaInconsistency.PropertyTypeNames').readOnly().build(),
];

const conservationField = GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_FIELDS[3];
conservationField.column.createFilter = (_localization, injector: Injector) => ({
  ...FieldBuilder.dropdown('conservationType', 'Entity.GisProtectedAreaInconsistency.ConservationType')
    .readOnly().build().column.createFilter!(_localization, injector),
  collectionAsync: defer(() => injector.get(ConservationTypeService).findByCodes({ codes: ['AMR', 'AC', 'CB', 'AAVC'] }))
    .pipe(map(types => [
      { value: '', label: '' },
      ...types.filter(type => type.description).map(type => ({ value: type.description!, label: type.description! })),
    ])),
});

const propertyTypeField = GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_FIELDS[4];
propertyTypeField.column.createFilter = (_localization, injector: Injector) => ({
  ...FieldBuilder.dropdown('propertyTypeNames', 'Entity.GisProtectedAreaInconsistency.PropertyTypeNames')
    .readOnly().build().column.createFilter!(_localization, injector),
  collectionAsync: defer(() => {
    const service = injector.get(PropertyTypeService);
    const page = (skipCount: number) => service.getList({ skipCount, maxResultCount: 1000, sorting: 'Id asc' })
      .pipe(map(result => ({ result, next: skipCount + result.items.length })));
    return page(0).pipe(
      expand(({ result, next }) => result.items.length && next < result.totalCount ? page(next) : EMPTY),
      reduce((names, { result }) => {
        result.items.forEach(type => { if (type.name) names.add(type.name); });
        return names;
      }, new Set<string>()),
      map(names => [{ value: '', label: '' }, ...Array.from(names)
        .sort((left, right) => {
          if (left === right) return 0;
          return left < right ? -1 : 1;
        })
        .map(name => ({ value: name, label: name }))]),
    );
  }),
});

export const GISPROTECTEDAREAINCONSISTENCY_PERMISSION = 'PlanningGeography.ProtectedAreas';

export const GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG = {
  entityName: 'GisProtectedAreaInconsistencyOnlyInZendra',
  localizationKey: 'Geographic::Entity.GisProtectedAreaInconsistency.OnlyInZendra',
  fields: GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_FIELDS,
  permission: GISPROTECTEDAREAINCONSISTENCY_PERMISSION,
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
